import { createDefaultTyrann } from '@apis/common';
import { checklist, patchChecklist } from '@models/Checklist';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const checklistApis = createDefaultTyrann({
  '/company/checklist/': {
    get: {
      response: {
        200: checklist,
      },
    },
    patch: {
      body: patchChecklist,
      response: {
        200: checklist,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
